import React from 'react'
import { badgeColors } from '../../Common/Color/Color'
import CustomBadge from '../../Common/Badge/CustomBadge'
import { fontSizes } from '../../Common/Typography/TypographyStyles'

// Define the props interface
interface OverviewBadgesProps {
  value: string
  badgeType: 'eventCategoryBadge' | 'taskImportanceBadge'
}

const OverviewBadges: React.FC<OverviewBadgesProps> = ({ value, badgeType }) => {
  const categoryColorMapping: Record<string, { label: string; color: string }> = {
    TIDS: {
      label: 'TIDS',
      color: badgeColors.brightBlue,
    },
    happyhere: {
      label: '#HAPPYHERE',
      color: badgeColors.purpleTelus,
    },
    teamEvent: {
      label: 'TEAM EVENT',
      color: badgeColors.softPink,
    },
    COP: {
      label: 'COP',
      color: badgeColors.teal,
    },
  }

  const importanceMapping: Record<string, string> = {
    Required: badgeColors.red,
    Optional: badgeColors.brightBlue,
  }

  const category = categoryColorMapping[value]

  if (badgeType === 'eventCategoryBadge') {
    return (
      <CustomBadge
        label={category?.label || value}
        size={fontSizes.size12}
        color={category?.color}
        width={100}
      />
    )
  }

  if (badgeType === 'taskImportanceBadge') {
    return (
      <CustomBadge
        rounded
        label={value}
        size={fontSizes.size12} // Reduced size for compactness
        color={importanceMapping[value]}
        width={80} // Adjusted width
      />
    )
  }

  // Optionally return null or a fallback UI for unexpected badge types
  return null
}

export default OverviewBadges
